// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Theme fallbacks */
/* Gold accents (matching your theme) */
.song {
  font-family: "Almendra", serif; /* site body font */
  padding-left: 12px;
  padding-right: 12px;
}

/* Title at the top (Great Vibes) */
.song__title {
  margin: 0;
  font-weight: 400; /* not bold */
  color: #0b0b0c;
  font-size: clamp(1.6rem, 4.2vw, 2.4rem);
  letter-spacing: 0.1px;
  font-family: "Great Vibes", cursive; /* explicit, as requested */
}

/* Thumbnail with thin gold edge; no overlay title */
.song__hero {
  margin: 0;
  border-radius: 11px;
  overflow: hidden;
  border: 1.5px solid transparent;
  background: linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, #d4af37, #f0e1a1 40%, #b38728) border-box;
  aspect-ratio: 16/9;
}
.song__hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}
.song__hero {
  /* remove the old overlay gradient since title is no longer on image */
}
.song__hero::before {
  display: none;
}

/* Centered credits — no borders/chips */
.song__credits {
  list-style: none;
  margin: 0.7rem 0 0;
  padding: 0;
  display: grid;
  gap: 0.5rem;
  justify-items: center; /* center each line horizontally */
}

.credit-line {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  /* no borders/background/shadows */
  border: 0;
  background: transparent;
  box-shadow: none;
  padding: 0.2rem 0;
}

.credit-line__icon {
  display: inline-flex;
  color: #926F34; /* switch to \$gold-1 for gold icons if preferred */
}
.credit-line__icon svg {
  width: 16px;
  height: 16px;
}

.credit-line__text {
  color: #0b0b0c;
  font-size: 0.98rem;
  line-height: 1;
  text-align: center;
}
.credit-line__text strong {
  font-weight: 700;
}

/* small screens tweaks */
@media (max-width: 520px) {
  .song__title {
    font-size: clamp(1.8rem, 8vw, 2.6rem);
  }
  .song__credits {
    gap: 0.45rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/SongComponent/SongComponent.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB,oBAAA;AAKA,uCAAA;AAOA;EACE,8BAAA,EAAA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAVF;;AAaA,mCAAA;AACA;EACE,SAAA;EACA,gBAAA,EAAA,aAAA;EACA,cApBQ;EAqBR,uCAAA;EACA,qBAAA;EACA,mCAAA,EAAA,2BAAA;AAVF;;AAaA,oDAAA;AACA;EACE,SAAA;EACA,mBArBO;EAsBP,gBAAA;EAEA,+BAAA;EACA,sHACE;EAGF,kBAAA;AAdF;AAgBE;EACE,WAAA;EAAa,YAAA;EACb,iBAAA;EAAmB,uBAAA;EACnB,cAAA;AAZJ;AAHA;EAkBE,sEAAA;AAZF;AAaE;EAAY,aAAA;AAVd;;AAaA,wCAAA;AACA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;EAEA,aAAA;EACA,WAAA;EACA,qBAAA,EAAA,kCAAA;AAXF;;AAcA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EAEA,kCAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AAZF;;AAeA;EACE,oBAAA;EACA,cA5EQ,EA4ES,kDAAA;AAZnB;AAaE;EAAM,WAAA;EAAa,YAAA;AATrB;;AAYA;EACE,cAhFQ;EAiFR,kBAAA;EACA,cAAA;EACA,kBAAA;AATF;AAWE;EAAS,gBAAA;AARX;;AAWA,yBAAA;AACA;EACE;IAAe,qCAAA;EAPf;EAQA;IAAiB,YAAA;EALjB;AACF","sourcesContent":["@use \"../styles/tokens\" as *;\r\n\r\n/* Theme fallbacks */\r\n$primary: if(global-variable-exists(color-primary), $color-primary, #7c3aed);\r\n$text:    if(global-variable-exists(color-text),   $color-text,   #0b0b0c);\r\n$muted:   if(global-variable-exists(color-muted),  $color-muted,  #6b7280);\r\n\r\n/* Gold accents (matching your theme) */\r\n$gold-1: #d4af37;\r\n$gold-2: #f0e1a1;\r\n$gold-3: #b38728;\r\n\r\n$radius: if(global-variable-exists(btn-radius), $btn-radius, 16px);\r\n\r\n.song {\r\n  font-family: 'Almendra', serif; /* site body font */\r\n  padding-left: 12px;\r\n  padding-right: 12px;\r\n}\r\n\r\n/* Title at the top (Great Vibes) */\r\n.song__title {\r\n  margin: 0;\r\n  font-weight: 400;                 /* not bold */\r\n  color: $text;\r\n  font-size: clamp(1.6rem, 4.2vw, 2.4rem);\r\n  letter-spacing: .1px;\r\n  font-family: 'Great Vibes', cursive;   /* explicit, as requested */\r\n}\r\n\r\n/* Thumbnail with thin gold edge; no overlay title */\r\n.song__hero {\r\n  margin: 0;\r\n  border-radius: $radius;\r\n  overflow: hidden;\r\n\r\n  border: 1.5px solid transparent;\r\n  background:\r\n    linear-gradient(#fff, #fff) padding-box,\r\n    linear-gradient(135deg, $gold-1, $gold-2 40%, $gold-3) border-box;\r\n\r\n  aspect-ratio: 16 / 9;\r\n\r\n  img {\r\n    width: 100%; height: 100%;\r\n    object-fit: cover; object-position: center;\r\n    display: block;\r\n  }\r\n\r\n  /* remove the old overlay gradient since title is no longer on image */\r\n  &::before { display: none; }\r\n}\r\n\r\n/* Centered credits — no borders/chips */\r\n.song__credits {\r\n  list-style: none;\r\n  margin: .7rem 0 0;\r\n  padding: 0;\r\n\r\n  display: grid;\r\n  gap: .5rem;\r\n  justify-items: center;  /* center each line horizontally */\r\n}\r\n\r\n.credit-line {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: .45rem;\r\n\r\n  /* no borders/background/shadows */\r\n  border: 0;\r\n  background: transparent;\r\n  box-shadow: none;\r\n  padding: .2rem 0;\r\n}\r\n\r\n.credit-line__icon {\r\n  display: inline-flex;\r\n  color: $primary; /* switch to $gold-1 for gold icons if preferred */\r\n  svg { width: 16px; height: 16px; }\r\n}\r\n\r\n.credit-line__text {\r\n  color: $text;\r\n  font-size: .98rem;\r\n  line-height: 1;\r\n  text-align: center;\r\n\r\n  strong { font-weight: 700; }\r\n}\r\n\r\n/* small screens tweaks */\r\n@media (max-width: 520px) {\r\n  .song__title { font-size: clamp(1.8rem, 8vw, 2.6rem); }\r\n  .song__credits { gap: .45rem; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
